export default function isString(value) {
    return typeof value === "string";
}
//# sourceMappingURL=is-string.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/common/is-string.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/is-string.js
// module chunks = 3